import { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Banner */}
      <section className="relative pt-20 h-[40vh] min-h-[300px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="O nas - Žar & Bar"
            className="w-full h-full object-cover"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="container mx-auto px-4 md:px-8 z-10 animate-fade-in">
          <h1 className="heading-xl text-white text-center">O nas</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-container">
        <div className="max-w-4xl mx-auto animate-fade-in">
          <h2 className="heading-lg mb-6 text-center">Naša zgodba</h2>
          <p className="paragraph mb-6">
            Žar & Bar Polskava je družinski lokal z večletno tradicijo, kjer se prepletata 
            ljubezen do dobre hrane in skrbno izbrana ponudba pijač. Naša zgodba se je začela 
            pred desetimi leti, ko smo združili kulinarično znanje in gostoljubnost, da bi 
            ustvarili prostor, kjer se ljudje počutijo kot doma.
          </p>
          <p className="paragraph mb-6">
            Začetki segajo v leto 2013, ko sta zakonca Novak, Marko in Ana, odprla majhen lokal 
            v središču Zgornje Polskave. Marko, kuhar z večletnimi izkušnjami v priznanih 
            restavracijah, je želel ustvariti prostor, kjer bi lahko izrazil svojo strast do 
            tradicionalne slovenske kuhinje, še posebej do jedi z žara. Ana, ki je delala kot 
            sommelierka, je k zgodbi dodala svoje strokovno znanje o vinih in drugih pijačah.
          </p>

          <div className="my-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <img
              src="https://images.unsplash.com/photo-1530632789071-8543f47edb34?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
              alt="Priprava hrane"
              className="rounded-lg shadow-lg h-80 w-full object-cover"
            />
            <img
              src="https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
              alt="Ambient bara"
              className="rounded-lg shadow-lg h-80 w-full object-cover"
            />
          </div>

          <h2 className="heading-md mb-6">Naša filozofija</h2>
          <p className="paragraph mb-6">
            V Žar & Bar Polskava verjamemo v pristnost, kakovost in domačnost. Vsaka jed, ki jo 
            postrežemo, je pripravljena z ljubeznijo in skrbjo, iz skrbno izbranih sestavin od 
            lokalnih dobaviteljev. Naš meni odraža bogastvo slovenske kulinarike, s poudarkom na 
            tradicionalnih jedeh z žara, ki so pripravljene po receptih, ki se prenašajo iz 
            generacije v generacijo.
          </p>
          <p className="paragraph mb-6">
            Naša ponudba pijač dopolnjuje kulinarično izkušnjo z izbranimi slovenskimi vini, 
            lokalnimi craft pivi in domačimi žganimi pijačami. Pri nas boste vedno našli nekaj 
            posebnega, kar bo zadovoljilo vaše brbončice.
          </p>
          
          <div className="section-divider my-8">
            <span className="font-display text-lg text-barbecue-600">Naše vrednote</span>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-8">
            <div className="text-center">
              <div className="bg-barbecue-100 text-barbecue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">1</span>
              </div>
              <h3 className="font-display text-xl font-semibold mb-2">Kakovost</h3>
              <p className="text-foreground/80">
                Uporabljamo samo najboljše sestavine in vsako jed pripravimo z največjo pozornostjo.
              </p>
            </div>
            <div className="text-center">
              <div className="bg-barbecue-100 text-barbecue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">2</span>
              </div>
              <h3 className="font-display text-xl font-semibold mb-2">Gostoljubnost</h3>
              <p className="text-foreground/80">
                Naša strast je ustvariti toplo in prijazno okolje, kjer se vsak gost počuti dobrodošlega.
              </p>
            </div>
            <div className="text-center">
              <div className="bg-barbecue-100 text-barbecue-600 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold">3</span>
              </div>
              <h3 className="font-display text-xl font-semibold mb-2">Lokalnost</h3>
              <p className="text-foreground/80">
                Podpiramo lokalne pridelovalce in s tem zagotavljamo svežino in avtentičnost naših jedi.
              </p>
            </div>
          </div>
          
          <h2 className="heading-md my-8">Naša ekipa</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <img
                src="https://images.unsplash.com/photo-1566554273541-37a9ca77b91f?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80"
                alt="Marko Novak"
                className="rounded-full w-40 h-40 object-cover mx-auto mb-4"
              />
              <h3 className="font-display text-xl font-semibold mb-1">Marko Novak</h3>
              <p className="text-barbecue-600 mb-3">Glavni kuhar in lastnik</p>
              <p className="text-foreground/80 text-sm">
                Z več kot 20 leti izkušenj v kulinariki je Marko mojster žara in duša naše kuhinje.
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://images.unsplash.com/photo-1587678711204-ca6d3d2f1f3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80"
                alt="Ana Novak"
                className="rounded-full w-40 h-40 object-cover mx-auto mb-4"
              />
              <h3 className="font-display text-xl font-semibold mb-1">Ana Novak</h3>
              <p className="text-barbecue-600 mb-3">Vodja bara in lastnica</p>
              <p className="text-foreground/80 text-sm">
                Ana je strokovnjakinja za vina in koktajle, ki skrbi za bogato ponudbo našega bara.
              </p>
            </div>
            <div className="text-center">
              <img
                src="https://images.unsplash.com/photo-1583394293214-28ded15ee548?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80"
                alt="Luka Horvat"
                className="rounded-full w-40 h-40 object-cover mx-auto mb-4"
              />
              <h3 className="font-display text-xl font-semibold mb-1">Luka Horvat</h3>
              <p className="text-barbecue-600 mb-3">Pomočnik kuharja</p>
              <p className="text-foreground/80 text-sm">
                Mlad in ambiciozen kuhar, ki v naš tim prinaša sveže ideje in energijo.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;